import { render } from "./howtoapply.vue?vue&type=template&id=43d1b046"
import script from "./howtoapply.vue?vue&type=script&lang=js"
export * from "./howtoapply.vue?vue&type=script&lang=js"

import exportComponent from "D:\\Projects\\GCTUSMS\\codev1\\apply_online\\frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__